import Hidden from './Hidden';

export default Hidden;
